import { configureStore, createReducer } from '@reduxjs/toolkit'

export interface GrowthbookStoreProps {
  features: Record<string, { defaultValue: any; rules: any[] }>
  attributes: Record<string, any>
}

const growthbookReducer = (props: GrowthbookStoreProps) =>
  createReducer(props, (builder) => {
    builder.addDefaultCase((state) => state)
  })

const growthbookStore = (props: GrowthbookStoreProps) =>
  configureStore({
    reducer: growthbookReducer(props)
  })

export default growthbookStore
